import React from 'react';
import PropTypes from 'prop-types';
import { Slide, SlideGroupContext } from '../../../components/SlideManager';

export const Fragment = ({ children, id, isDone, isEmpty, onEntered, onExiting, setValue }) => {
    const context = React.useContext(SlideGroupContext);

    const onSelectValue = (value, stop) => {
        if (value && !stop) {
            context.next();
        }
        setValue(value);
    };

    const style = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    };

    return (
        <Slide
            id={id}
            isDone={isDone}
            isEmpty={isEmpty}
            onEntered={onEntered}
            onExiting={onExiting}
        >
            <div style={style} className="odf-bg-base">
                { children({ onSelectValue }) }
            </div>
        </Slide>
    );
};

Fragment.propTypes = {
    children: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    isDone: PropTypes.bool.isRequired,
    isEmpty: PropTypes.bool.isRequired,
    onEntered: PropTypes.func,
    onExiting: PropTypes.func,
    setValue: PropTypes.func.isRequired,
};

Fragment.defaultProps = {
    onEntered: () => {},
    onExiting: () => {},
};
